<template>
  <div class="row" :class="errorClass" v-if="displayField">
    <div class="col-md-4 col-lg-4 col-xl-3">
      <label class="h6 text-md-right">
        <span v-html="label"></span> <br>
        <small class="text-black-50">{{labelSecondary}}</small>
      </label>
    </div>
    <div class="col-md-8 col-lg-8 col-xl-9">
      <div class="form-group">
        <label class="text-black-50"><small>File formats: pdf, doc, docx, mp4</small></label>
        <input
          type="file"
          class="form-control-file"
          :required="isRequired"
          v-on:change="actionFileUpload($event)"
          accept=".pdf, .doc, .docx, .mp4, odt, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/pdf, video/mp4, application/vnd.oasis.opendocument.text">
      </div>
      <div v-if="errorClass !== ''" class="alert alert-danger mt-1" role="alert">
        Please complete this field
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: [
    'label',
    'labelSecondary',
    'isRequired',
    'displayField',
    'errorClass'
  ],
  data () {
    return {
      fileContent: ''
    }
  },
  methods: {
    actionFileUpload: function (upload) {
      this.$emit('addedFileinputContent', {label: this.label, content: upload.target.files[0], validated: true, displayField: this.displayField})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FieldFileInput.vue